<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout justify-center>
        <v-dialog v-model="show" transition="dialog-bottom-transition">

            <v-card>
                <v-toolbar dark color="blue lighten-2" dense>
                    <v-btn icon dark @click="show = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Группа модулей</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                    </v-toolbar-items>
                </v-toolbar>
                <v-list class="content">
                    <v-container mx-4>
                        <v-tabs vertical>
                            <v-tab v-for="(moduleMethods, indexCategory) in moduleCategories"
                            :key="indexCategory">
                                <v-flex>
                                    <v-badge bottom>
                                        <template v-slot:badge>{{moduleMethods.length}}</template>
                                        {{ categories[indexCategory] !== undefined ? categories[indexCategory].name : indexCategory}}
                                    </v-badge>
                                </v-flex>
                            </v-tab>
                            <v-tab-item
                                    v-for="(moduleMethods, indexCategory) in moduleCategories"
                                    :key="indexCategory"
                            >

                                    <v-layout wrap>
                                        <v-flex
                                                v-for="(moduleMethod, indexMethod) in moduleMethods"
                                                :key="moduleMethod.id"
                                                xs3
                                                md3
                                                class="pa-1"
                                        >
                                                <v-card outlined flat height="100%" class="pa-1">
                                                    <v-card-title style="height: 2.5em">
                                                        <span class="bold body-2">{{moduleMethod.title}}</span>
                                                    </v-card-title>
                                                    <v-card-text style="height: 8em">
                                                        <span class="caption">{{moduleMethod.description}}</span>
                                                    </v-card-text>
                                                    <v-card-actions >
                                                        <v-btn
                                                                block
                                                                color="blue lighten-2"
                                                                dark
                                                                @click="addMethodToGroup(indexCategory, indexMethod)"
                                                        >
                                                            Выбрать
                                                        </v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                        </v-flex>
                                    </v-layout>
                            </v-tab-item>
                        </v-tabs>
                    </v-container>
                </v-list>
            </v-card>
        </v-dialog>
        <v-snackbar
                v-model="snackbar"
                bottom
                color="success"
                right
        >
            Успешно сохранено!
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </v-layout>

</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'ModuleSelectBlock',
    components: {},
    data() {
        return {
            show: false,
            snackbar: false,
            categories: {
                main: { name: 'Все' },
                clients: { name: 'Пользователи' },
                fedresurs: { name: 'Фед. ресурс' },
                googleDocs: { name: 'Google Docs' },
                variables: { name: 'Переменные' },
                inline: { name: 'Inline' },
                market: { name: 'Маркет' },
                moysklad: { name: 'МойСклад.ру' },
                botControl: { name: 'Контроль бота' },
                mailing: { name: 'Рассылки' },
                messages: { name: 'Сообщения' },
                card: { name: 'Заказы' },
                text: { name: 'Текст' },
                referral: { name: 'Рефералы' },
                vk: { name: 'ВКонтакте' },
                binance: { name: 'Биржа Binance' },
                shop: { name: 'Торговый бот' }
            }
        }
    },
    methods: {
        addMethodToGroup(indexCategory, indexMethod) {
            let model = Object.assign({}, this.moduleGroups[this.moduleGroupIndex])
            let methodId = this.moduleCategories[indexCategory][indexMethod].id
            let newModule = {}
            newModule[methodId] = this.moduleCategories[indexCategory][indexMethod].template
            // eslint-disable-next-line eqeqeq
            if (this.mode == 0) {
                let newStructure = []
                if (model.structure.length === 0) {
                    newStructure = [newModule]
                } else {
                    newStructure = model.structure.slice()
                    newStructure.push(newModule)
                }
                model.structure = newStructure
                this.$store.dispatch('moduleGroups/saveModuleGroup', model)
            } else {
                this.$emit('addModule', newModule)
            }
            this.$emit('close')
        }
    },
    props: ['dialog', 'moduleGroupIndex', 'mode'], /* mode - режим выбора модуля: 0 - стандартный, 1 - вызывает событие */
    computed: {
        ...mapGetters({
            moduleCategories: 'modules/moduleMethods', // todo добавить разделение по категориям
            moduleGroups: 'moduleGroups/moduleGroups',
            moduleModel: 'modules/modelDefault',
            modules: 'modules/modules'
        })
    },
    watch: {
        dialog() {
            this.dialog === true ? this.show = true : this.show = false
        },
        show() {
            if (!this.show) { this.$emit('close') }
        }
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }
    .container {
        width: 100vw;
        height: 70vh;
        display: flex;
        flex-direction: column;
    }

    .content {
        flex-grow: 1;
        overflow-x: auto;
    }
</style>
